import { notification } from "@mtm/components";
import moment from "moment";
import { sendEmailBookingCancel } from "../services/EmailNotificationService";
import {
  NotificationTripBooking,
  NotificationTripBookingService,
  EmailTripBookingModel,
} from "../types/EmailNotificationType";
import { ITripDetails } from "../components/ServiceUsers/Interfaces/ITripDetails";
import { getTripByRequestAssignmentId } from "../services";

const EmailTripBooking = async (
  trip: EmailTripBookingModel,
  wandaCustomerCareNumber: string
) => {
  try {
    const apiResponse = await getTripByRequestAssignmentId({
      requestAssignmentId: trip.requestAssignmentId,
      personId: trip.serviceUserPersonId,
      favoriteId: 0,
      tripDate: moment.utc(trip.tripDate).format(),
    });
    const tripLegs = apiResponse.personTrips.sort(
      (a: ITripDetails, b: ITripDetails) =>
        a.bookingId.localeCompare(b.bookingId)
    );
    const tripServiceData: NotificationTripBookingService[] = tripLegs.map(
      (tripService: ITripDetails) => {
        return {
          serviceId: tripService.tripId,
        };
      }
    );

    const bookingCancelDetails: NotificationTripBooking = {
      eventId: trip.eventId,
      personId: trip.careGiverPersonId,
      organizationId: trip.organizationId,
      caregiverName: trip.careGiverName,
      bookingId: trip.bookingId,
      customerServicePhone: wandaCustomerCareNumber,
      serviceDate: moment(trip.tripDate).format("MM/DD/YYYY"),
      sourceSystemId: trip.sourceSystemId,
      serviceType: tripLegs[0]?.typeOfService,
      serviceUserPersonId: trip.serviceUserPersonId,
      services: tripServiceData,
    };
    await sendEmailBookingCancel(bookingCancelDetails);
  } catch (error) {
    notification.error({
      message: "Error",
      description: "Failed to send email.",
    });
  }
};

export default EmailTripBooking;
